import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { QueryString } from "@grandvisionhq/utils";
import { useRoutingContext } from "../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import LinkedAppointmentInfo from "./LinkedAppointmentInfo.js";
const AppointmentInfoContainer = ({ className, ...rest }) => {
  const { getLabel } = useIntl();
  const [, { queryParams, basePath, currentRoute }] = useRoutingContext();
  const { linkedAppointmentTypeIdIsAvailable, alternativeAppointmentTypeIdIsAvailable } = React.useMemo(() => {
    const isWhereRoute = currentRoute === "" || currentRoute === "where";
    const isWhenRoute = currentRoute === "when";
    if (!isWhereRoute && !isWhenRoute) {
      return {};
    }
    const linkedAppointmentTypeIdIsAvailable2 = !!queryParams?.linkedAppointmentTypeId;
    const alternativeAppointmentTypeIdIsAvailable2 = !!queryParams?.alternativeLinkedAppointmentTypeId;
    return {
      linkedAppointmentTypeIdIsAvailable: linkedAppointmentTypeIdIsAvailable2,
      alternativeAppointmentTypeIdIsAvailable: alternativeAppointmentTypeIdIsAvailable2
    };
  }, [
    currentRoute,
    queryParams?.linkedAppointmentTypeId,
    queryParams?.alternativeLinkedAppointmentTypeId
  ]);
  const { urlToBeReplacedForLinkedAppointmentType, urlToBeReplacedForAlternativeAppointmentType } = React.useMemo(() => {
    if (!linkedAppointmentTypeIdIsAvailable && !alternativeAppointmentTypeIdIsAvailable) {
      return {};
    }
    const queryParamsOfInterest = {
      ...queryParams,
      linkedAppointmentTypeId: void 0,
      alternativeLinkedAppointmentTypeId: void 0
    };
    let urlToBeReplacedForLinkedAppointmentType2 = "";
    let urlToBeReplacedForAlternativeAppointmentType2 = "";
    if (linkedAppointmentTypeIdIsAvailable) {
      queryParamsOfInterest.typeId = queryParams.linkedAppointmentTypeId;
      urlToBeReplacedForLinkedAppointmentType2 = `${basePath}/${currentRoute}${QueryString.stringify(
        queryParamsOfInterest
      )}`;
    }
    if (alternativeAppointmentTypeIdIsAvailable) {
      queryParamsOfInterest.typeId = queryParams.alternativeLinkedAppointmentTypeId;
      urlToBeReplacedForAlternativeAppointmentType2 = `${basePath}/${currentRoute}${QueryString.stringify(
        queryParamsOfInterest
      )}`;
    }
    return {
      urlToBeReplacedForLinkedAppointmentType: urlToBeReplacedForLinkedAppointmentType2,
      urlToBeReplacedForAlternativeAppointmentType: urlToBeReplacedForAlternativeAppointmentType2
    };
  }, [
    linkedAppointmentTypeIdIsAvailable,
    alternativeAppointmentTypeIdIsAvailable,
    queryParams,
    basePath,
    currentRoute
  ]);
  const labels = React.useMemo(
    () => ({
      linkedAppointmentTitle: getLabel("appointments.component.linkedAppointmentInfo.title"),
      linkedAppointmentCta: getLabel("appointments.component.linkedAppointmentInfo.cta"),
      alternativeAppointmentTitle: getLabel(
        "appointments.component.alternativeAppointmentInfo.title"
      ),
      alternativeAppointmentCta: getLabel("appointments.component.alternativeAppointmentInfo.cta")
    }),
    [getLabel]
  );
  if (!linkedAppointmentTypeIdIsAvailable && !alternativeAppointmentTypeIdIsAvailable) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    LinkedAppointmentInfo,
    {
      ...{
        labels,
        className,
        linkedAppointmentTypeIdIsAvailable,
        alternativeAppointmentTypeIdIsAvailable
      },
      linkedAppointmentCtaUrl: urlToBeReplacedForLinkedAppointmentType,
      alternativeAppointmentCtaUrl: urlToBeReplacedForAlternativeAppointmentType,
      ...rest
    }
  );
};
export {
  AppointmentInfoContainer as default
};
//# sourceMappingURL=LinkedAppointmentInfoContainer.js.map
